export function FIXSocket() {
  const ws = new WebSocket(process.env.REACT_APP_FIX_STREAMING);
  return ws;
}

export function ReportSocket() {
  return new WebSocket(process.env.REACT_APP_REPORT_STREAMING);
}
